import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Select from 'react-select';
import { mapObjIndexed, values } from 'ramda';

import cx from 'classnames';
import s from './Profile.css';
import { removeEmptyAriaOwns } from '../../../../lib/a11yUtils';

const AccessibleValue = ({ value }) => (
  <div className="Select-value" title={value.label}>
    <span className="Select-value-label">{value.label}</span>
  </div>
);


class AdditionalInfo extends Component {
  componentDidMount() {
    removeEmptyAriaOwns(this.sectionRef);
  }

  componentDidUpdate() {
    removeEmptyAriaOwns(this.sectionRef);
  }

  render() {
    const { fields, options, labels, updateValue } = this.props;
    return (
    <section className={s.component} ref={el => this.sectionRef = el}>
      <h3 className={s.header}>
        Additional Information
      </h3>
      {values(mapObjIndexed((field, key) =>
        <div className={s.group} key={key}>
          <label
            id={`additionalInfo__${key}`}
            htmlFor={`additionalInfo__${key}Input`}
            className={s.label}
          >
            {labels[key]}
          </label>
          <div className={s.controlContainer}>
            <Select
              id={`additionalInfo__${key}Input`}
              aria-labelledby={`additionalInfo__${key}`}
              className={cx(s.flex, "composeMessage")}
              optionClassName="composeMessage__option"
              searchable={false}
              clearable={false}
              value={field}
              options={options[key]}
              onChange={val => updateValue(key, val.value)}
              inputProps={{id: `additionalInfo__${key}Input`, 'aria-labelledby': `additionalInfo__${key}`, 'aria-haspopup': 'listbox'}}
              valueComponent={AccessibleValue}
            />
          </div>
        </div>, fields)
      )}
    </section>
    );
  }
}

AdditionalInfo.propTypes = {
  fields: PropTypes.object,
  options: PropTypes.object,
  labels: PropTypes.object,
  updateValue: PropTypes.func,
};

export default AdditionalInfo;



// WEBPACK FOOTER //
// ./src/components/Pages/Account/Profile/AdditionalInfo.js